import { MutableRefObject, useRef } from 'react';
import { Button, Modal } from 'react-bootstrap';

interface ITermConditionModal {
  show: boolean;
  onHide: any;
  onOk: any;
}

const TermConditionModal = (props: ITermConditionModal) => {
  const okButtonEl = useRef() as MutableRefObject<HTMLButtonElement>;

  return (
    <Modal
      show={props.show}
      size="lg"
      onHide={props.onHide}
      centered /*onEntered={() => okButtonEl?.current?.focus()}*/
    >
      <Modal.Body className="text-14">
        <div className="gb-inside-container">
          <p className="gb-headline gb-headline-f1cdc950 gb-headline-text">
            <strong>TERMS AND CONDITIONS OF ACCESS</strong>
            <br />
            <br />
            By using any of the websites (including any online services operated
            thereat) by or for Strides Premier Private Hire and Limousine Pte. Ltd. (hereinafter known as ”
            Strides Premier Private Hire and Limousine “) and/or its direct or indirect subsidiaries
            (hereinafter individually and collectively with Strides Premier Private Hire and Limousine ,
            known as the ” Strides Premier Private Hire and Limousine Group”, and each such website being
            a “Website”), you agree to be bound by the following Terms of Use
            (“Terms”). If you do not accept any of the following Terms, please
            discontinue access immediately. These Terms may be changed from time
            to time. Changes will be posted on this page and your use of the
            Websites after such changes have been posted will constitute your
            unconditional agreement to the modified Terms and all of the
            changes.
            <br />
            <br />
            <strong>COPYRIGHT &amp; TRADEMARKS NOTICE</strong>
            <br />
            <br />
            Except as otherwise expressly stated herein, all rights, title and
            interest in and to any Website, its contents and the online services
            therein, are owned by the Strides Premier Private Hire and Limousine Group. No part of any
            Website may be reproduced, distributed, republished, retransmitted,
            disseminated, displayed, adapted, altered, hyperlinked or otherwise
            used in any form or by any means without the prior written consent
            of the Strides Premier Private Hire and Limousine Group. You also may not, without the prior
            written consent of the Strides Premier Private Hire and Limousine Group, mirror or frame any
            part or whole of the contents of any Website on any other server
            wherever situated or as part of any other website.
            <br />
            <br />
            All proprietary content, trademarks, service marks, brand names,
            logos and other intellectual property displayed in any Website are
            the property of the Strides Premier Private Hire and Limousine Group and where applicable,
            third party proprietors identified in any Website. No right or
            licence is granted directly or indirectly to any party accessing any
            Website to use or reproduce any such proprietary content,
            trademarks, service marks, brand names, logos and other intellectual
            property, and no party accessing any Website shall claim any right,
            title or interest therein are of any other website. In addition, you
            agree that you will not use any of the following but not limited to,
            robot, spider, software, programme, algorithm or any other automatic
            device or manual process to monitor or copy our web pages or the
            content contained herein, without the prior written consent of the
            Strides Premier Private Hire and Limousine Group (such consent is deemed given for standard
            search engine technology employed by Internet search websites to
            direct Internet users to any Website).
            <br />
            <br />
            <strong>NO UNLAWFUL OR HARMFUL USE</strong>
            <br />
            <br />
            You may not use any Website in any way that breaches any code of
            conduct, policy or other notice applicable to any Website. You agree
            that you will not use any device, software or other instrument to,
            directly or indirectly, interfere or attempt to interfere with:
            <br />
            <br />
            1. the proper working of any Website;
            <br />
            2.&nbsp;any other party’s use and enjoyment of any Website; and
            <br />
            3. that you will not, directly or indirectly, take any action that
            could damage, disable, overburden, or impair any Website or the
            networks connected to any Website.
            <br />
            <br />
            You must not misuse any Website by knowingly introducing viruses,
            Trojans, worms, logic bombs or other material which is malicious or
            technologically harmful. You must not attempt to gain unauthorised
            access to any Website, the server on which any Website is stored on
            any server, computer or database connected to any Website. You must
            not attack any Website via a denial-of-service attack or a
            distributed denial-of service attack. You agree that Strides Premier Private Hire and Limousine
            Group will not be liable for any loss or damage caused by a
            distributed denial-of-service attack, viruses or other
            technologically harmful material that may infect your computer
            equipment, computer programs, data or other proprietary material due
            to your use of any Website or to your downloading of any material
            posted on it, or on any website linked to it.
            <br />
            <br />
            You represent and warrant that all information provided by you to
            Strides Premier Private Hire and Limousine Group in connection with your use of any Website is
            accurate, current and complete and you agree to hold harmless and
            indemnify Strides Premier Private Hire and Limousine Group against any breach by you of the
            foregoing warranty in accordance with the provisions of these terms
            and conditions.
            <br />
            <br />
            <strong>DISCLAIMER</strong>
            <br />
            <br />
            The information and materials contained in any Website are provided
            on an “as is” and “as available” basis without warranty of any kind,
            either express or implied, including but not limited to the
            warranties of title, merchantability, satisfactory quality,
            non-infringement of third party intellectual property rights and
            freedom from computer virus as well as fitness for a particular
            purpose. You further acknowledge and agree that any use by you of
            any content submitted by any third party is entirely at your own
            risk. Strides Premier Private Hire and Limousine Group shall not bear any liability in
            connection with any use of any content made available on any Website
            or any infringement of any rights arising in connection therewith,
            and you hereby release Strides Premier Private Hire and Limousine Group from any and all
            claims in connection therewith. Strides Premier Private Hire and Limousine Group does not and
            is not in a position to verify any party’s rights to submit any
            content on the Website, and Strides Premier Private Hire and Limousine Group takes no
            responsibility and assumes no liability for any content posted by
            you or any third party, or for use of the same. Strides Premier Private Hire and Limousine
            Group does not in any way endorse or support the views or ideas
            expressed in any submitted content.
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group also does not warrant the truth,
            accuracy, timeliness, adequacy, completeness or reasonableness of
            such information and materials and expressly disclaims liability for
            any errors in, or omissions from such information and materials.
            Such information and materials have been prepared solely for the
            purpose of providing general information about the Strides Premier Private Hire and Limousine
            Group and its operational activities, may be changed by the Strides Premier Private Hire and Limousine
            Group at any time and must not be relied upon in connection
            with any investment decision. You should seek professional advice at
            all times and obtain independent verification of the information and
            materials before making any decision based on such information and
            materials. The information and materials contained in any Website
            shall not be construed as an offer or a solicitation to sell, buy,
            give, take, issue, allot or transfer, or as the giving of any advice
            in respect of shares, stocks, bonds, notes, interests, unit trusts,
            mutual funds or other securities, investments, loans, advances,
            credits or deposits in any jurisdiction.
            <br />
            <br />
            <strong>EXCLUSION OF LIABILITY</strong>
            <br />
            <br />
            In no event shall the Strides Premier Private Hire and Limousine Group nor any of its
            officers, employees, agents, affiliates or licensors be liable for
            any damages, loss or expense including but not limited to direct,
            indirect, special, incidental or consequential damage or loss
            arising in connection with any access or use of any Website, or
            reliance on any information and materials provided in any Website or
            any failure of performance, system, server or connection failure,
            error, omission, interruption, delay in transmission, computer
            virus, or unavailability of access regardless of the form of action
            and even if the Strides Premier Private Hire and Limousine Group had been advised as to the
            possibility of such damages.
            <br />
            <br />
            For the avoidance of doubt, any commentary and other materials
            posted on any Website by users or third party content providers are
            not intended to amount to advice on which reliance should be placed.
            Strides Premier Private Hire and Limousine Group therefore disclaims all liability and
            responsibility arising from any reliance placed on such materials by
            any visitor to any Website, or by anyone who may be informed of any
            of its contents.
            <br />
            <br />
            <strong>INDEMNIFICATION</strong>
            <br />
            <br />
            You agree to hold harmless and indemnify the Strides Premier Private Hire and Limousine Group,
            and its officers, employees, agents, affiliates and licensors from
            and against any claims, actions, proceedings, investigations,
            demands, losses, damages, suits, judgments, awards, costs and
            expenses (including but not limited to legal expenses on a full
            indemnity basis) of every kind and nature arising from or in any way
            related to any breach by you of these terms and conditions and your
            use of any Website and/or the online services herein.
            <br />
            <br />
            <strong>HYPERLINKS AND THIRD PARTY CONTENT</strong>
            <br />
            <br />
            Any hyperlink included in any Website and resources provided by
            third parties are for information only and are not an endorsement or
            verification of such linked websites. You agree that Strides Premier Private Hire and Limousine
            Group has no control over the contents of these websites or
            resources and assumes no responsibility for the contents of or the
            consequences or for any loss or damage that may arise from accessing
            such linked websites.
            <br />
            <br />
            You agree that your access to and/or the use of any such linked
            website is entirely at your own risk and subject to the terms and
            conditions of access and/or use contained therein. We are not
            responsible for the privacy practices of any such linked website,
            and encourage you to familiarise yourself with the privacy policies
            of such third party websites. Some of these third party websites may
            be co-branded with our logo or trademark, even though they are not
            operated or maintained by us. Once you are directed to any third
            party website, you should check the applicable personal data policy
            of the third party website to determine how they will handle any
            personal data which they may collect from you.
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group is not responsible for any third party
            content (including but not limited to any computer viruses or other
            disabling features), nor does Strides Premier Private Hire and Limousine Group have any
            obligation to monitor such third party content. The Strides Premier Private Hire and Limousine
            Group reserves the right at all times to remove or refuse to
            distribute any content on any Website.
            <br />
            <br />
            <strong>MISCELLANEOUS</strong>
            <br />
            <br />
            The headings used in these terms and conditions are for ease of
            reference only and shall not be taken into account in the
            construction or interpretation of any provision to which they refer.
            <br />
            <br />
            If any provision of these terms and conditions is held to be invalid
            or unenforceable, in whole or in part, under any enactment or rule
            of law, such term or provision or part thereof shall to that extent
            be deemed not to form part of this Agreement but the validity and
            enforceability of the remainder of these terms and conditions shall
            not be affected.
            <br />
            The Strides Premier Private Hire and Limousine Group’s failure to act with respect to a breach
            by you or others does not amount to it waiving its right to act with
            respect to subsequent or similar breaches.
            <br />
            <br />A person who is not a party to any agreement governed by these
            terms and conditions has no right under the Contracts (Rights of
            Third Parties) Act (Cap. 53B) to enforce any of these terms and
            conditions.
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group reserves the right to modify, delete or
            replace the information and materials contained herein from time to
            time and at any time in its absolute discretion. Your continued use
            of any Website after the effective date of such changes constitutes
            your acceptance of and agreement to such changes.
            <br />
            <br />
            <strong>GOVERNING LAW AND JURISDICTION</strong>
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group makes no representation that the
            information and materials contained in or accessed through any
            Website is appropriate or available for use in any jurisdictions
            outside the Republic of Singapore. You agree that by accessing any
            Website and/or using the online services herein, your access and/or
            use, as well as these terms and conditions shall be governed by and
            construed in accordance with the laws of the Republic of Singapore
            and you agree to submit to the non-exclusive jurisdiction of the
            courts of the Republic of Singapore.
            <br />
            <br />
            <strong>PRIVACY</strong>
            <br />
            <br />
            When you access any Website and online services, the Strides Premier Private Hire and Limousine
            Group may collect the following information:f the Website,
            please contact us at 1800 336 8900. We will endeavour to investigate
            all matters brought to our attention.
          </p>

          <p className="gb-headline gb-headline-686f7b47 gb-headline-text">
            Anonymous web statistics collected as you browse the websites
            <br />
            Personal data you knowingly provide us
          </p>

          <p className="gb-headline gb-headline-7d42d65c gb-headline-text">
            Some portions of the Website may also require that you provide your
            personal data.
            <br />
            <br />
            -“Personal data” refers to any data, whether true or not, about an
            individual who can be identified (a) from that data; or (b) from
            that data and other information to which we have or are likely to
            have access, including data in our records as may be updated from
            time to time (including but not limited to your name, contact
            number, email address and mailing address which may be obtained by
            us via your access to or use of any Website).
            <br />
            <br />
            Please do not submit any personal data without first reading our
            Privacy Policy accessible here{' '}
            <a href="https://stridespremier.com.sg/privacy-policy/">
              https://stridespremier.com.sg/privacy-policy/
            </a>{' '}
            which sets out our privacy practices in relation to personal data.
            <br />
            <br />
            Any information disclosed in the public areas of the website (such
            as message boards and forums) becomes public information. You should
            exercise caution when disclosing your personal data in this manner.
            <br />
            <br />
            <strong>CONTENT POSTED OR SUBMITTED TO Strides Premier Private Hire and Limousine</strong>
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group may provide interactive services on any
            Website, including, without limitation, chat rooms and bulletin
            boards (“Interactive Services”). Strides Premier Private Hire and Limousine Group are under no
            obligation to oversee, monitor or moderate any Interactive Service
            provided on any Website, and any liability for any loss or damage
            arising from the use of any Interactive Service by a user in
            contravention of the terms and conditions of access stated herein,
            whether the service is moderated or not, is expressly excluded.
            <br />
            <br />
            Whenever you make use of a feature that allows you to upload
            material to any Website (“Contributions”), or to make contact with
            other users of any Website, you must not post or transmit any
            unlawful, threatening, libelous, defamatory or profane material or
            any material that could constitute or encourage conduct that would
            be considered a criminal offence, give rise to civil liability, or
            otherwise violate any law, breach any laws relating to the
            protection of personal data, infringe any intellectual property
            rights, or otherwise be injurious to third parties. In particular,
            but without limiting the generality of the foregoing:
            <br />
            <br />
            i. Contributions must:
          </p>

          <p className="gb-headline gb-headline-a93a9b4f gb-headline-text">
            be accurate (where they state facts)
            <br />
            be genuinely held (where they state opinions)
            <br />
            comply with applicable law and codes of practice issued by any
            regulatory agency in Singapore and in any country from which they
            are posted or to be received
          </p>

          <p className="gb-headline gb-headline-7b722726 gb-headline-text">
            ii. Contributions must not
          </p>

          <p className="gb-headline gb-headline-5e8c2a3c gb-headline-text">
            contain any material which is defamatory of any person
            <br />
            contain any material which is obscene, offensive, hateful or
            inflammatory
            <br />
            promote sexually explicit material
            <br />
            promote violence
            <br />
            promote discrimination based on race, sex, religion, nationality,
            disability, sexual orientation or age
            <br />
            infringe any copyright, database right or trade mark or other
            intellectual property or other rights of any other person or
            advocate, promote, authorise or assist any unlawful act such as (by
            way of example only) copyright infringement or computer misuse
            <br />
            be likely to deceive any person
            <br />
            be made in breach of any legal duty owed to a third party, such as a
            contractual duty or a duty of confidence
            <br />
            promote any illegal activity
            <br />
            be threatening, abuse or invade another’s privacy, or cause
            annoyance, inconvenience or needless anxiety
            <br />
            be likely to harass, upset, embarrass, alarm or annoy any other
            person
            <br />
            be used to impersonate any person, or to misrepresent your identity
            or affiliation with any person
            <br />
            give the impression that they emanate from us, if this is not the
            case
          </p>

          <p className="gb-headline gb-headline-8e4dbe2b gb-headline-text">
            (collectively, “Content Standards”). These Content Standards apply
            to any and all Contributions which you contribute to any Website and
            to any Interactive Services associated with it. You must comply with
            the spirit of the Content Standards as well as the letter. The
            Content Standards apply to each part of and the whole of any
            Contribution.
            <br />
            <br />
            You warrant your Contributions will comply with the Content
            Standards, and Strides Premier Private Hire and Limousine Group may without notice and without
            any liability to you remove or disable access to any Contributions
            which in its opinion do not comply with the Content Standards. You
            will further indemnify Strides Premier Private Hire and Limousine Group for any breach of this
            warranty. Strides Premier Private Hire and LimousinGroup will not be responsible, or liable
            to any third party, for the content or accuracy of any materials
            posted by you or any other user of any Website.
            <br />
            <br />
            You agree to grant to the Strides Premier Private Hire and Limousine Group a non-exclusive,
            royalty-free, worldwide, perpetual license, with the right to
            sublicense, reproduce, distribute, transmit, create derivative works
            of, publicly display and publicly perform any materials and other
            information (including, without limitation, ideas contained therein
            for new or improved products and services) you submit to public
            areas of the website (such as message boards, forums, member
            profiles, job folders or other features that allow users to post
            information that will be accessible by the public or the user
            population generally) by all means and in any media now known or
            hereafter developed. You also grant to the Strides Premier Private Hire and Limousine Group
            the right (though you acknowledge and agree that the Strides Premier Private Hire and Limousine
            Group shall not be so obliged) to use your name in
            connection with the submitted materials and other information as
            well as in connection with all advertising, marketing and
            promotional material related thereto. You agree that you shall have
            no recourse against the Strides Premier Private Hire and Limousine Group for any alleged or
            actual infringement or misappropriation of any proprietary right in
            your communications to us.
            <br />
            <br />
            If you agree to provide us access to any social media networking
            account, you also consent to granting Strides Premier Private Hire and Limousine Group access
            to your friend lists, content and apps linked to your social media
            networking account, to retain copies thereof and provide other users
            access thereto to enable social networking or other features or
            functionality interfacing with such platform.
            <br />
            <br />
            Except for any personal, individually identifying information which
            we have specifically agreed with you to keep confidential in
            writing, any feedback, data, answers, questions, comments,
            suggestions, plans, ideas or the like that you send to us via the
            Website, email or otherwise, will be treated as being
            non-confidential and non-proprietary. The Strides Premier Private Hire and Limousine Group
            assumes no obligation to protect such information from disclosure
            and will be free to reproduce, use, and distribute the information
            to others without restriction. We will also be free to use any
            ideas, concepts, know-how or techniques contained in information
            that you send us for any purpose whatsoever including but not
            limited to developing, manufacturing and marketing products and
            services incorporating such information.
            <br />
            <strong>
              <br />
              HYPERLINKS FROM THIRD PARTY WEBSITES
            </strong>
            <br />
            <strong>
              <br />
            </strong>
            You agree that caching, hyperlinking to, and framing of any Website
            or any of the contents are strictly prohibited.
            <br />
            <br />
            The Strides Premier Private Hire and Limousine Group reserves all rights to disable any links
            to, or frames of any site containing inappropriate, profane,
            defamatory, infringing, obscene, indecent or unlawful topics, names,
            material or information, or material or information that violates
            any written law, any applicable intellectual property, proprietary,
            privacy or publicity rights.
            <br />
            <br />
            <strong>COOKIES</strong>
            <br />
            <br />
            By visiting any Website with your browser settings adjusted to
            accept cookies, you consent to our use of cookies and other similar
            technologies to provide our services. You can however modify the
            settings in your browser to notify you when you receive a new cookie
            and disable cookies altogether but doing so may reduce functionality
            of the Website.
            <br />
            We may use cookies and store these on your computer through your web
            browser to enable our systems to recognise your browser and to
            provide services or advertisements which may be tailored to your
            preferences. Cookies may also identify you when you sign-in to our
            Website, and may be used by us to deliver content, including
            advertisements, relevant to your interests, conducting research and
            diagnostics to improve our content, products and services, prevent
            fraudulent activities and improve security.
            <br />
            <br />
            <strong>Cookies and Browser Settings</strong>
            <br />
            <br />
            The Help menu on the menu bar of most browsers will tell you how to
            prevent your browser from accepting new cookies, how to have the
            browser notify you when you receive a new cookie and how to disable
            cookies altogether. Additionally, you can disable or delete similar
            data used by browser add-ons, such as Flash cookies, by changing the
            add-on’s settings or visiting the website of its manufacturer.
            <br />
            <br />
            Advertisers and other third-parties may make use of information
            stored in your cookies. We may not have access to or control over
            cookies or other features that advertisers and third party sites may
            use, and the information and privacy practices of these advertisers
            and third party websites will be governed by their terms. Please
            contact these parties directly for more information about their
            practices relating to cookies and the handling of personal data.
            <br />
            <br />
            <strong>TERMINATION AND SUSPENSION</strong>
            <br />
            <br />
            Strides Premier Private Hire and Limousine Group will determine, in its discretion, whether
            there has been a breach of the aforesaid terms and conditions of
            access through your use of our website. Failure to comply with terms
            and conditions of access constitutes a material breach, and may
            result in Strides Premier Private Hire and Limousine Group taking actions against you,
            including but not limited to the following:
          </p>

          <p className="gb-headline gb-headline-2f21fc7e gb-headline-text">
            immediate, temporary or permanent withdrawal of your right to use
            any Website
            <br />
            immediate, temporary or permanent removal of any posting or material
            uploaded by you to any Website
            <br />
            issue a warning to you
            <br />
            initiate legal proceedings against you for reimbursement of all
            costs on an indemnity basis (including, but not limited to,
            reasonable administrative and legal costs) resulting from the breach
            <br />
            further legal action against you
            <br />
            disclosure of such information to law enforcement authorities as
            Strides Premier Private Hire and Limousine Group may reasonably opine is necessary
          </p>

          <p className="gb-headline gb-headline-e85401cf gb-headline-text">
            Strides Premier Private Hire and Limousine Group excludes liability for actions taken in
            response to breaches of these terms and conditions of access.
            <br />
            <br />
            <strong>GENERAL</strong>
            <br />
            <br />
            Strides Premier Private Hire and Limousine Group is committed that all contents made available
            via the Website is appropriate for our users and not offensive. If
            you have any concerns over the contents of the Website, please
            contact us at 1800 336 8900. We will endeavour to investigate all
            matters brought to our attention.
          </p>
        </div>
        <div className="text-center">
          <Button
            variant="danger"
            className="mr-2 text-15 font-weight-bold"
            onClick={() => props.onOk()}
            ref={okButtonEl}
            tabIndex={-1} // Enables key handlers on div
          >
            OK
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default TermConditionModal;
